export enum OrgTypes {
  supplier = 'SUPPLIER',
  enterpriseCustomer = 'ENTERPRISE_CUSTOMER',
  capitalProvider = 'CAPITAL_PROVIDER',
  champion = 'CHAMPION',
  capacityProvider = 'CAPACITY_PROVIDER'
}
